module.exports = "/shifts/components/tips/unassignedShift-071c5a.html";